<section class="weather__table">
    <div class="inner wrap relative">
        <div class="info-tit-box">
            <span class="txt">
                {{ "weatherTable.title" | translate }}
            </span>
            <a (click)="toggleTableDescription()" class="info-btn"></a>
            <article *ngIf="isVisibleTableDescription" class="time-by-weather">
                <div class="time-by-weather-wrap">
                    <div class="tit-box">
                        <div class="tit-txt">
                            {{ "weatherTable.iconLegend" | translate }}
                        </div>
                        <a (click)="toggleTableDescription()" class="close-btn"></a>
                    </div>
                    <ul>
                        <li>
                            <div class="box">
                                <i class="ic ic1"></i>
                                <span class="box-txt">
                                    {{ "weather.time" | translate }}
                                </span>
                            </div>
                        </li>
                        <li>
                            <div class="box">
                                <i class="ic ic2"></i>
                                <span class="box-txt">
                                    {{ "weather.windSpeed" | translate }}
                                </span>
                            </div>
                        </li>
                        <li>
                            <div class="box">
                                <i class="ic ic3"></i>
                                <span class="box-txt">
                                    {{ "weather.windGust" | translate }}
                                </span>
                            </div>
                        </li>
                        <li>
                            <div class="box">
                                <i class="ic ic4"></i>
                                <span class="box-txt">
                                    {{ "weather.temperature" | translate }}
                                </span>
                            </div>
                        </li>
                        <li>
                            <div class="box">
                                <i class="ic ic5"></i>
                                <span class="box-txt">
                                    {{ "weather.humidity" | translate }}
                                </span>
                            </div>
                        </li>
                        <li>
                            <div class="box">
                                <i class="ic ic6"></i>
                                <span class="box-txt">
                                    {{ "weather.precipitationShort" | translate }}
                                </span>
                            </div>
                        </li>
                        <li>
                            <div class="box">
                                <i class="ic ic7"></i>
                                <span class="box-txt">
                                    {{ "weather.cloudCover" | translate }}
                                </span>
                            </div>
                        </li>
                        <li>
                            <div class="box">
                                <i class="ic ic8"></i>
                                <span class="box-txt">
                                    {{ "weather.sight" | translate }}
                                </span>
                            </div>
                        </li>
                        <li>
                            <div class="box">
                                <i class="ic ic9"></i>
                                <span class="box-txt">
                                    {{ "weather.satelliteCount" | translate }}
                                </span>
                            </div>
                        </li>
                        <li>
                            <div class="box">
                                <i class="ic ic10"></i>
                                <span class="box-txt">
                                    {{ "weather.kpIndex" | translate }}
                                </span>
                            </div>
                        </li>
                        <li>
                            <div class="box">
                                <i class="ic ic11"></i>
                                <span class="box-txt">
                                    {{ "weather.flightStatus" | translate }}
                                </span>
                            </div>
                        </li>
                    </ul>
                </div>
            </article>

            <div class="sub-menu-box">
                <div class="cbox">
                    <label>
                        <input type="checkbox" (click)="changeVisibleTime()" [checked]="isOnlySunrise">
                        <i></i>
                        <span class="txt">
                            {{ "weatherTable.dayTime" | translate }}
                        </span>
                    </label>
                </div>
            </div>
        </div>

        <div class="table__group">
            <div *ngFor="let weatherListItemDto of getDisplayedWeatherList(); let i = index;" class="table-list-box" [class.type-on]="weatherListItemDto.isVisible">
                <div class="table-list-tit" (click)="toggleItemVisible(i)">
                    <div class="list-tit-txt accent">
                        {{ dateService.getFullDateWithDay(weatherListItemDto.date) }}
                    </div>
                    <div *ngIf="weatherListItemDto.sunrise != null" class="sun-time-box">
                        <span class="sun-txt type-on">
                            {{ dateService.getTime(weatherListItemDto.sunrise) }}
                        </span>
                        <span class="sun-txt type-off">
                            {{ dateService.getTime(weatherListItemDto.sunset) }}
                        </span>
                    </div>
                    <div *ngIf="weatherListItemDto.sunrise == null" class="sun-time-box">
                        <span class="sun-txt type-on">
                            -
                        </span>
                        <span class="sun-txt type-off">
                            -
                        </span>
                    </div>
                    <div class="table-list-menu">
                        <a class="toggle-btn type-on"></a>
                    </div>
                </div>

                <div class="table-list-form">
                    <table>
                        <thead>
                        <tr>
                            <th>
                                <i class="ic1"></i>
                            </th>
                            <th>
                                <i class="ic2"></i>
                            </th>
                            <th>
                                <i class="ic3"></i>
                            </th>
                            <th>
                                <i class="ic4"></i>
                            </th>
                            <th>
                                <i class="ic5"></i>
                            </th>
                            <th>
                                <i class="ic6"></i>
                            </th>
                            <th>
                                <i class="ic7"></i>
                            </th>
                            <th>
                                <i class="ic8"></i>
                            </th>
                            <th>
                                <i class="ic9"></i>
                            </th>
                            <th>
                                <i class="ic10"></i>
                            </th>
                            <th>
                                <i class="ic11"></i>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let weatherInfo of weatherListItemDto.infos; let j = index;">
                                <td class="type-center {{ flightStatusName.convertCodeToClass(getFlightStatusCode(i, j)) }}">
                                    <span class="txt">
                                        {{ dateService.getTime(weatherInfo.timeTag) }}
                                    </span>
                                </td>
                                <td class="{{ flightStatusName.convertCodeToClass(weatherInfo.getWindStatus(flightConfiguration)) }}">
                                    <span class="txt">
                                        {{ userUnit.convertCalculatedWindSpeed(weatherInfo.data.windSpeed) }}
                                    </span>
                                    <span class="arrow">
                                        <i class="ic-arrow" [ngStyle]="weatherInfo.getDirectionStyle()"></i>
                                    </span>
                                </td>
                                <td class="{{ isContainedGust == true? flightStatusName.convertCodeToClass(weatherInfo.getWindGustStatus(flightConfiguration, isContainedGust)): '' }}">
                                    <span class="txt">
                                        {{ userUnit.convertCalculatedWindSpeed(weatherInfo.data.windGust) }}
                                    </span>
                                    <span class="arrow">
                                        <i class="ic-arrow" [ngStyle]="weatherInfo.getDirectionStyle()"></i>
                                    </span>
                                </td>
                                <td [class.accent]="flightConfiguration.minimumTemperature > weatherInfo.data.temperature || weatherInfo.data.temperature > flightConfiguration.maximumTemperature">
                                    <span class="txt">
                                        {{ userUnit.convertCalculatedTemperature(weatherInfo.data.temperature) }}
                                        {{ userUnit.convertTemperatureUnitText() }}
                                    </span>
                                </td>
                                <td [class.accent]="flightConfiguration.maximumHumidity != null && (weatherInfo.data.humidity > flightConfiguration.maximumHumidity || flightConfiguration.minimumHumidity > weatherInfo.data.humidity)">
                                    <span class="txt">
                                        {{ weatherInfo.data.humidity }}
                                        %
                                    </span>
                                </td>
                                <td [class.accent]="weatherInfo.data.precipitation > flightConfiguration.precipitation">
                                    <span class="txt">
                                        {{ weatherInfo.data.precipitation }}
                                        %
                                    </span>
                                </td>
                                <td class="{{ flightStatusName.convertCodeToClass(weatherInfo.getCloudCoverStatus(flightConfiguration)) }}">
                                    <span class="txt">
                                        {{ weatherInfo.data.totalCloudCover }}
                                        %
                                    </span>
                                </td>
                                <td [class.accent]="weatherInfo.data.visibility != 0 && flightConfiguration.visibility > weatherInfo.data.visibility">
                                    <span class="txt">
                                        {{ userUnit.convertCalculatedDistance(weatherInfo.data.visibility) }}
                                    </span>
                                </td>
                                <td [class.accent]="i == 0 && j == 0 && flightConfiguration.satelliteCount > currentSatelliteCount">
                                    <span *ngIf="i == 0 && j == 0" class="txt">
                                        {{ currentSatelliteCount }}
                                    </span>
                                    <span *ngIf="i != 0 || j != 0" class="txt">
                                        -
                                    </span>
                                </td>
                                <td *ngIf="displayedKpList.length > i && displayedKpList[i].infos.length > j" [class.accent]="displayedKpList[i].infos[j].kp >= kpStandard.DANGEROUS_KP">
                                    <span  class="txt">
                                        {{ displayedKpList[i].infos[j].kp }}
                                    </span>
                                </td>
                                <td *ngIf="!(displayedKpList.length > i && displayedKpList[i].infos.length > j)">
                                    <span class="txt">
                                        -
                                    </span>
                                </td>
                                <td class="type-center {{ flightStatusName.convertCodeToClass(getFlightStatusCode(i, j)) }}">
                                    <i *ngIf="getFlightStatusCode(i, j) == flightStatusCode.GOOD" class="fly-on"></i>
                                    <i *ngIf="getFlightStatusCode(i, j) == flightStatusCode.CARE" class="fly-mid"></i>
                                    <i *ngIf="getFlightStatusCode(i, j) == flightStatusCode.DANGER" class="fly-off"></i>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="table-toggle-btn-box">
                <a class="table-toggle-btn" [class.on]="isVisibleList" (click)="toggleListVisible()">
                    <span *ngIf="!isVisibleList">
                        {{ "weatherTable.showAllList" | translate }}
                    </span>
                    <span *ngIf="isVisibleList">
                        {{ "weatherTable.hideAllList" | translate }}
                    </span>
                </a>
            </div>
        </div>
    </div>
</section>